const days = [
	'Select day of birth',
	'1',
	'2',
	'3',
	'4',
	'5',
	'6',
	'7',
	'8',
	'9',
	'10',
	'11',
	'12',
	'13',
	'14',
	'15',
	'16',
	'17',
	'18',
	'19',
	'20',
	'21',
	'22',
	'23',
	'24',
	'25',
	'26',
	'27',
	'28',
	'29',
	'30',
	'31',
];

const months = [
	{ month: '0', label: 'Select month of birth' },
	{ month: '1', label: 'Jan' },
	{ month: '2', label: 'Feb' },
	{ month: '3', label: 'Mar' },
	{ month: '4', label: 'Apr' },
	{ month: '5', label: 'May' },
	{ month: '6', label: 'Jun' },
	{ month: '7', label: 'Jul' },
	{ month: '8', label: 'Aug' },
	{ month: '9', label: 'Sep' },
	{ month: '10', label: 'Oct' },
	{ month: '11', label: 'Nov' },
	{ month: '12', label: 'Dec' },
];

export { days, months };
